import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as SupperAnalystSVG } from '../../../../../assets/images/ai.svg';

import { Avatar, Dropdown, DropdownMenuItem, IconButton } from '../../../../../components';

const ConversationParticipantsContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

const StyledDropdown = styled(Dropdown)`
  left: 15px;
`;

const StyledIconButton = styled(IconButton)`
  z-index: 1;
  background-color: #fef5ed;

  &:hover:not(:active),
  &:active,
  &:focus {
    background-color: #fef5ed;
  }
`;

const StyledSupperAnalystSVG = styled(SupperAnalystSVG)`
  width: 24px;
  height: 24px;
  display: inline-flex;
  flex-shrink: 0;
`;

const ConversationParticipants = ({ participants, onShareClick }) =>
  participants.length > 0 ? (
    <ConversationParticipantsContainer>
      <StyledDropdown
        menuPlacement='bottom-end'
        toggleComponent={<IconButton iconName='shared' primary onClick={onShareClick} />}
      >
        {() => (
          <>
            {participants.map(({ id, name, picture }) => (
              <DropdownMenuItem
                key={id}
                leftIcon={
                  id === 'sup-an' ? (
                    <StyledSupperAnalystSVG width={24} height={24} />
                  ) : (
                    <Avatar src={picture} />
                  )
                }
              >
                {name}
              </DropdownMenuItem>
            ))}
          </>
        )}
      </StyledDropdown>
      <StyledIconButton iconName='plus' secondary onClick={onShareClick} />
    </ConversationParticipantsContainer>
  ) : (
    <IconButton iconName='shared' naked onClick={onShareClick} />
  );

ConversationParticipants.propTypes = {
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired
    })
  ).isRequired,
  onShareClick: PropTypes.func.isRequired
};

export { ConversationParticipants };
